import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/avatar.webp'
import _imports_1 from '../../assets/avatar.png'


const _withScopeId = n => (_pushScopeId("data-v-27cd403d"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_1
const _hoisted_3 = { class: "profile grid" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<picture data-v-27cd403d><source srcset=\"" + _hoisted_1 + "\" type=\"image/webp\" data-v-27cd403d><source srcset=\"" + _hoisted_2 + "\" type=\"image/png\" data-v-27cd403d><img height=\"150px\" width=\"150px\" alt=\"Profile Avatar\" class=\"avatar load-hidden\" src=\"" + _imports_1 + "\" data-v-27cd403d></picture><a href=\"#\" class=\"tooltip load-hidden\" data-v-27cd403d><h1 class=\"name\" data-v-27cd403d>@mack</h1><span class=\"tooltiptext\" data-v-27cd403d>Mackenzie Boudreau</span></a><h3 class=\"role load-hidden\" data-v-27cd403d>Software Engineer</h3>", 3)
const _hoisted_8 = { class: "buttons load-hidden" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "pdf/mackboudreau_public_resume.pdf",
  class: "button cta"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-cloud-arrow-down" }),
  /*#__PURE__*/_createTextVNode(" View Resume ")
], -1))
const _hoisted_10 = { class: "sub-buttons" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "button button__small button__gray",
  href: "https://www.halihax.com",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-slack" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-paper-plane" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mail = _resolveComponent("Mail")!
  const _component_ThemeButton = _resolveComponent("ThemeButton")!
  const _component_SocialList = _resolveComponent("SocialList")!
  const _component_Stats = _resolveComponent("Stats")!

  return (_openBlock(), _createElementBlock("header", _hoisted_3, [
    _createVNode(_component_Mail, { ref: "mailForm" }, null, 512),
    _createVNode(_component_ThemeButton),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_SocialList)
    ]),
    _createVNode(_component_Stats),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("a", {
          class: "button button__small button__gray",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$refs.mailForm.show()))
        }, _hoisted_13)
      ])
    ])
  ]))
}